import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatMoney } from './utils';

export const generateTablePDF = (
  data: any[],
  headers: any[],
  title?: string,
  filename?: string
) => {
  const doc = new jsPDF('landscape');
  let startY = 20;

  // Debug: Log the input data to see what we're working with
  console.log('Input data for PDF:', data);
  console.log('Headers for PDF:', headers);

  // Add title if provided
  if (title) {
    doc.setFontSize(16);
    doc.text(title, 14, startY);
    startY += 15;
  }

  // Format data for the table
  const formattedData = data.map((row, index) => {
    const formattedRow: any = {};
    headers.forEach((header) => {
      const value = row[header.key];
      
      // Format based on data type
      if (header.type === 'money' && typeof value === 'number') {
        formattedRow[header.key] = formatMoney(value);
      } else if (header.type === 'date' && value) {
        // You can add date formatting here if needed
        formattedRow[header.key] = value;
      } else if (value === null || value === undefined) {
        formattedRow[header.key] = header.nullValue || '-';
      } else if (typeof value === 'number' && !isNaN(value)) {
        // Format any numeric value as money if it's a number
        formattedRow[header.key] = formatMoney(value);
      } else if (typeof value === 'string' && !isNaN(Number(value))) {
        // Handle string numbers
        const numValue = Number(value);
        if (!isNaN(numValue)) {
          formattedRow[header.key] = formatMoney(numValue);
        } else {
          formattedRow[header.key] = value;
        }
      } else {
        formattedRow[header.key] = value;
      }
    });
    return formattedRow;
  });

  // Debug: Log the formatted data to see what's being generated
  console.log('Formatted data for PDF:', formattedData);

  // Create columns configuration for autoTable
  const columns = headers.map(header => ({
    title: header.label,
    dataKey: header.key
  }));

  // Generate the table
  autoTable(doc, {
    columns: columns,
    startY: startY,
    body: formattedData,
    theme: 'grid',
    headStyles: {
      fillColor: '#efefef',
      textColor: '#1b1b1b',
      fontStyle: 'bold',
      halign: 'left',
      valign: 'middle',
      lineColor: [44, 62, 80],
      fontSize: 8,
    },
    bodyStyles: {
      textColor: [50, 50, 50],
      fontSize: 7,
    },
    styles: {
      font: 'helvetica',
      lineColor: [44, 62, 80],
      lineWidth: 0.1,
    },
    margin: { top: 10, right: 10, bottom: 10, left: 10 },
    tableWidth: 'auto',
    horizontalPageBreak: true,
    pageBreak: 'auto',
    showFoot: 'lastPage',
  });

  // Save the PDF
  const defaultFilename = `Deuda-${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(filename || defaultFilename);
};
